import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withRouter } from "react-router-dom";
import { Button, withStyles, Box } from "@material-ui/core";
import FormDialog from "../../../shared/components/FormDialog";
import HighlightedInformation from "../../../shared/components/HighlightedInformation";
import ButtonCircularProgress from "../../../shared/components/ButtonCircularProgress";
import VisibilityPasswordTextField from "../../../shared/components/VisibilityPasswordTextField";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as AuthActions from "../../../redux/actions/auth";
import { makeValidate, makeRequired, showErrorOnBlur } from 'mui-rff';
import styled from 'styled-components';
import sleep from './../../../shared/functions/sleep';
import * as yup from 'yup';
import passwordSetup from 'shared/functions/passwordSetup';

const schema = yup.object().shape({
  password: passwordSetup(),
  password_confirm: yup.string().required('Password confirmation is required').oneOf([yup.ref('password'), null], 'Passwords must match')
});
const validate = makeValidate(schema);
const required = makeRequired(schema);

const styles = (theme) => ({});

class PasswordDialog extends PureComponent {

  state = { 
    status: false 
  };

  componentDidMount(){
    this.setState({status: this.props.status})
  }

  componentDidUpdate(prevProps){
    if(prevProps.status !== this.props.status){
      this.setState({status: this.props.status})
    }
  }

  setStatus(status){
    this.setState({status})
  }

  onFormSubmit = async (data) => {
    const { history } = this.props;
    this.setStatus(null);

    this.props.onContinue(data)
  };

  render() {
    const { classes, onClose, initialValues, description, forceEnableSubmitButton, onBack } = this.props;
    const { status } = this.state;

    return (
      <Fragment>
        <FormDialog
          open
          status={status && status.general}
          onClose={onClose}
          validate={validate}
          initialValues={initialValues}
          onFormSubmit={(data) => this.onFormSubmit(data)}
          headline="Welcome"
          description={description || "This is your first visit to our site, please set your login password."}
          maxWidth="sm"
          content={({ submitting }) =>
            <Fragment>

              <VisibilityPasswordTextField
                name="password"
                label="Password"
                margin="dense"
                autoComplete="off"
                // front end validation
                required={required.password}
                showError={showErrorOnBlur}
                // server side errors
                helperText={status && status.password}
                // inject only when needed, else it messes internal error prop
                {...{ [status && status.password && 'error']: status && status.password }}
              />

              <VisibilityPasswordTextField
                name="password_confirm"
                label="Confirm Password"
                margin="dense"
                autoComplete="off"
                // front end validation
                required={required.password_confirm}
                showError={showErrorOnBlur}
                // server side errors
                helperText={status && status.password_confirm}
                // inject only when needed, else it messes internal error prop
                {...{ [status && status.password_confirm && 'error']: status && status.password_confirm }}
              />

            </Fragment>
          }
          actions={({ submitting, pristine }) =>
            <Fragment>
              <Button
                type="button"
                variant="contained"
                color="default"
                disabled={submitting}
                onClick={() => onBack ? onBack({initialValues}) : onClose()}
              >
                Back
              </Button>

              <Button
                type="submit"
                variant="contained"
                color="secondary"
                disabled={(submitting || pristine) && !forceEnableSubmitButton}
              >
                Continue
                {submitting && <ButtonCircularProgress />}
              </Button>
            </Fragment>
          }
        />
      </Fragment>
    );
  }
}

export default connect(null, (dispatch) =>
  bindActionCreators({ ...AuthActions }, dispatch)
)(withRouter(withStyles(styles)(PasswordDialog)));
